import { parseISO } from 'date-fns'

import { VIEWING_TERMINAL_STATUSES } from '../../../../../constants/rentalPortal'

export function getApplicantCurrentViewing(viewings) {
  const sorted = [...viewings].sort(
    (left, right) => parseISO(right.start) - parseISO(left.start)
  )

  return (
    sorted.find(
      viewing => !VIEWING_TERMINAL_STATUSES.includes(viewing.status)
    ) ?? sorted[0]
  )
}
